// semeia-disable-reexport
import type { EmberChangeset } from "ember-changeset";
import type { InsOid } from "parog-web/cnam/types";
import { InsStatus, InsType } from "parog-web/cnam/types";

export function computeInsStatus({
  insDocumentIsQualifying,
  insStatus
}:
  | {
      insDocumentIsQualifying: boolean;
      insStatus: InsStatus;
    }
  | EmberChangeset): InsStatus {
  const insHasBeenRetrieved = [
    InsStatus.Qualified,
    InsStatus.Recovered
  ].includes(insStatus as InsStatus);

  if (insDocumentIsQualifying) {
    return insHasBeenRetrieved ? InsStatus.Qualified : InsStatus.Validated;
  }
  return insHasBeenRetrieved ? InsStatus.Recovered : InsStatus.Provisional;
}

export function getInsStatusLabel(insStatus: InsStatus): string {
  switch (insStatus) {
    case InsStatus.Validated:
      return "Identité validée";
    case InsStatus.Recovered:
      return "Identité récupérée";
    case InsStatus.Qualified:
      return "Identité qualifiée";
    default:
      return "Identité provisoire";
  }
}

export function getInsStatusExplanation(insStatus: InsStatus): string {
  switch (insStatus) {
    case InsStatus.Validated:
      return "Contrôle d’identité OK - Pas de vérification de l’INS";
    case InsStatus.Recovered:
      return "Pas de contrôle d’identité  - Vérification de l’INS OK";
    case InsStatus.Qualified:
      return "Contrôle d’identité OK - Vérification de l’INS OK";
    default:
      return "Pas de contrôle d’identité  -  Pas de vérification de l’INS";
  }
}

export function getInsStatusColor(insStatus: InsStatus): string {
  switch (insStatus) {
    case InsStatus.Validated:
      return "yellow";
    case InsStatus.Recovered:
      return "orange";
    case InsStatus.Qualified:
      return "green";
    default:
      return "red";
  }
}

export function getInsType(insOid?: InsOid): InsType {
  // 1.2.250.1.213.1.4.8 => Numéro INS de production
  // 1.2.250.1.213.1.4.9 => Numéro NIA (Numéro d'identification d'attente)
  // 1.2.250.1.213.1.4.10 => Numéro INS de test
  // 1.2.250.1.213.1.4.11 => Numéro INS de démonstration
  if (insOid == "1.2.250.1.213.1.4.8") {
    return InsType.NIR;
  } else if (insOid == "1.2.250.1.213.1.4.9") {
    return InsType.NIA;
  }

  return InsType.UNKNOWN;
}

export function filterStringValue(value: string): string {
  return value
    ? value
        .normalize("NFD")
        // This range correspond to the diacritics codes : https://en.wikipedia.org/wiki/Combining_Diacritical_Marks
        .replace(/[\u0300-\u036f]/g, "")
        .toUpperCase()
        .replace(/"/g, "'")
        .replace(/`/g, "'")
        .replace(/’/g, "'")
        .replace(/[^A-Z\s-']/g, "")
    : "";
}
